import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

// importing all the themes

import HomePage from "../pages/homePage";
import ErrorPage from "../components/ErrorPage/404";
import PrivacyPolicy from "../components/PrivacyPolicy/PrivacyPolicy"
import TermsAndConditions from "../components/TermsAndConditions/TermsAndConditions"
import GetFurrbudApp from "../components/GetFurrbudApp/GetFurrbudApp";
import ImposterPrivacyPolicy from "../components/ImposterTAC/PrivacyPolicy";
import ImposterTermsAndConditions from "../components/ImposterTAC/TermsAndConditions";
import GetImposterApp from "../components/GetImposterApp/GetImposterApp";
import SayOnBeatPrivacyPolicy from "../components/SayOnBeatTAC/PrivacyPolicy";
import SayOnBeatTermsAndConditions from "../components/SayOnBeatTAC/TermsAndConditions";
import GetSayOnBeatApp from "../components/GetSayOnBeatApp/GetSayOnBeatApp";
import HeadsUpPrivacyPolicy from "../components/HeadsUpTAC/PrivacyPolicy";
import HeadsUpTermsAndConditions from "../components/HeadsUpTAC/TermsAndConditions";
import GetHeadsUpApp from "../components/GetHeadsUpApp/GetHeadsUpApp";

class MyRouts extends React.Component {
  render() {
    return (
      <div>
        <Router>
          <Switch>
            <Route exact path="/" component={HomePage} />
            <Route path="/error-page" component={ErrorPage} />
            <Route path="/privacy-policy" component={PrivacyPolicy}/>
            <Route path="/terms-and-conditions" component={TermsAndConditions}/>
            <Route path="/get-guesswhonever-app" component={GetFurrbudApp}/>
            <Route path="/imposter/privacy-policy" component={ImposterPrivacyPolicy}/>
            <Route path="/imposter/terms-and-conditions" component={ImposterTermsAndConditions}/>
            <Route path="/get-imposter-app" component={GetImposterApp}/>
            <Route path="/sayonbeat/privacy-policy" component={SayOnBeatPrivacyPolicy}/>
            <Route path="/sayonbeat/terms-and-conditions" component={SayOnBeatTermsAndConditions}/>
            <Route path="/get-sayonbeat-app" component={GetSayOnBeatApp}/>
            <Route path="/headsup/privacy-policy" component={HeadsUpPrivacyPolicy}/>
            <Route path="/headsup/terms-and-conditions" component={HeadsUpTermsAndConditions}/>
            <Route path="/get-headsup-app" component={GetHeadsUpApp}/>
          </Switch>
        </Router>
      </div>
    );
  }
}
export default MyRouts;
